import {createStore} from "vuex";
import {Auth, certMailStatuses, certPasswordStatuses} from "@/data-models/auth";
import createPersistedState from "vuex-persistedstate";
import {differenceInHours} from "date-fns";

const shouldShowLogoutMessageLimitHours = 2

type authStoreType = {
    token: string,
    auth: Auth,
    lastUpdatedAt: Date,
    staffNotificationShowed: boolean,
}

export const authStore = createStore<authStoreType>({
    state: {
        token: "",
        auth: new Auth(),
        lastUpdatedAt: new Date(),
        staffNotificationShowed: false,
    },
    mutations: {
        updateToken (state, payload) {
            state.token = payload.token
            state.lastUpdatedAt = new Date()
        },
        clearToken (state) {
            state.token = ""
            state.lastUpdatedAt = new Date()
        },
        updateAuth (state, payload) {
            // state.auth = payload.auth
            // updateAuthExceptCertで発生したクラスインスタンスが単なるオブジェクトになってしまう問題はこちらでも起きているはず。顕現はしていないが。
            state.auth = new Auth()
            state.auth.replaceWithOther(payload.auth)
        },
        updateAuthExceptCert(state, payload) {
            // console.log(state.auth)
            // ページ再読み込み時にPersistedState（local storage）から再構築する際、クラスインスタンスではなく単なるObjectになってしまうので、クラスインスタンスを生成し、内容を書きなおす。
            if (state.auth.constructor.name !== "Auth") {
                const tmpAuth = state.auth
                state.auth = new Auth()
                state.auth.replaceWithOther(tmpAuth)
            }
            // console.log(state.auth.constructor.name)
            state.auth.replaceExceptCert(payload.auth)
        },
        clearAuth (state) {
            state.auth = new Auth()
        },
        updatePasswordValidity (state, payload) {
            state.auth.cert.password = payload.password
        },
        updateEmailValidity (state, payload) {
            state.auth.cert.mail = payload.mail
        },
        updateStaffNotificationShowed (state, payload) {
            state.staffNotificationShowed = payload
        }
    },
    getters: {
        existsToken (state): boolean {
            // console.log(state.token)
            return state.token.length > 0
        },
        authLevel (state): string {
            return state.auth.authLevel
        },
        shouldShowLoggedOut (state): boolean {
            return differenceInHours(state.lastUpdatedAt, new Date()) < shouldShowLogoutMessageLimitHours
        },
        shouldUpdatePassword (state): boolean {
            return state.auth.cert.password !== certPasswordStatuses.updated
        },
        shouldVerifyMail (state): boolean {
            return state.auth.cert.mail !== certMailStatuses.verified
        },
        shouldUpdateAuths (state, getters): boolean {
            return getters.shouldUpdatePassword || getters.shouldVerifyMail
        }
    },
    plugins: [
        createPersistedState(),
        (store) => {
            // vuex-persistedstate はJSON.parse/stringifyでシリアライズするため、リロード時に
            // state.auth が Auth クラスのインスタンスではなく単なるObjectとして復元され、
            // Auth.prototype 上のgetter（authLevel, hasAccountingPrev等）が失われる。
            // この結果、router.beforeEach の一番最初の authStore.getters.authLevel チェックが
            // 常にundefinedを返し、SHOULD_UPDATEオーバーレイの対象レベル判定が常に失敗していた
            // （updateAuth/updateAuthExceptCertには同様の復元処理が既にあるが、どちらも
            // このチェックより後にしか呼ばれないため間に合わない）。
            // ストア作成直後（createPersistedStateの復元が終わった直後）に一度だけ、
            // 確実にAuthクラスのインスタンスへ復元しておく。
            if (store.state.auth.constructor.name !== "Auth") {
                const tmpAuth = store.state.auth
                store.state.auth = new Auth()
                store.state.auth.replaceWithOther(tmpAuth)
            }
        },
    ],
})